/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerFindOneQueryResponse, ProjectsControllerFindOnePathParams, ProjectsControllerFindOneQueryParams, ProjectsControllerFindOne400, ProjectsControllerFindOne401, ProjectsControllerFindOne403, ProjectsControllerFindOne404 } from "../../models/projectsController/ProjectsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectsControllerFindOne } from "../../clients/projectsService/projectsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectsControllerFindOneQueryKey = (id: ProjectsControllerFindOnePathParams["id"], params: ProjectsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/projects/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ProjectsControllerFindOneQueryKey = ReturnType<typeof projectsControllerFindOneQueryKey>;
export function projectsControllerFindOneQueryOptions(id: ProjectsControllerFindOnePathParams["id"], params?: ProjectsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectsControllerFindOneQueryKey(id, params);
  return queryOptions<ProjectsControllerFindOneQueryResponse, ResponseErrorConfig<ProjectsControllerFindOne400 | ProjectsControllerFindOne401 | ProjectsControllerFindOne403 | ProjectsControllerFindOne404>, ProjectsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a project by id
 * {@link /api/v1/projects/:id}
 */
export function useProjectsControllerFindOne<TData = ProjectsControllerFindOneQueryResponse, TQueryData = ProjectsControllerFindOneQueryResponse, TQueryKey extends QueryKey = ProjectsControllerFindOneQueryKey>(id: ProjectsControllerFindOnePathParams["id"], params?: ProjectsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ProjectsControllerFindOneQueryResponse, ResponseErrorConfig<ProjectsControllerFindOne400 | ProjectsControllerFindOne401 | ProjectsControllerFindOne403 | ProjectsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...projectsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectsControllerFindOne400 | ProjectsControllerFindOne401 | ProjectsControllerFindOne403 | ProjectsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}